import React, { useState } from 'react'
import { FaEye } from 'react-icons/fa'
import { IoStarSharp } from 'react-icons/io5'
import { ModalFeedback } from './modalFeedback'
import { useIntl } from 'react-intl'

const categories = {
	1: { color: '#6C4FDB', icon: '', name: { pt: 'Comunicação', es: 'Comunicación' } },
	2: { color: '#6C4FDB', icon: '', name: { pt: 'Trabalho em equipe', es: 'Trabajo en equipo' } },
	3: { color: '#008ACD', icon: '', name: { pt: 'Produtividade', es: 'Productividad' } },
	4: { color: '#6C4FDB', icon: '', name: { pt: 'Liderança', es: 'Liderazgo' } },
	5: { color: '#00A28B', icon: '', name: { pt: 'Adaptabilidade e Flexibilidade', es: 'Adaptabilidad y flexibilidad' } },
	6: { color: '#D87706', icon: '', name: { pt: 'Competências técnicas', es: 'Competencias técnicas' } },
	7: { color: '#D87706', icon: '', name: { pt: 'Orientação ao cliente', es: 'Orientación al cliente' } },
	8: { color: '#D87706', icon: '', name: { pt: 'Pontualidade', es: 'Puntualidad' } },
	9: { color: '#D87706', icon: '', name: { pt: 'Responsabilidade e Comprometimento', es: 'Responsabilidad y compromiso' } },
	10: { color: '#00A28B', icon: '', name: { pt: 'Atitude', es: 'Actitud' } },
	11: { color: '#00A28B', icon: '', name: { pt: 'Ética e integridade', es: 'Ética e integridad' } },
	12: { color: '#6C4FDB', icon: '', name: { pt: 'Gestão de conflitos', es: 'Gestión de conflictos' } },
	13: { color: '#008ACD', icon: '', name: { pt: 'Gestão de tempo', es: 'Gestión del tiempo' } },
	14: { color: '#008ACD', icon: '', name: { pt: 'Resolução de problemas', es: 'Resolución de problemas' } },
	15: { color: '#00A28B', icon: '', name: { pt: 'Proatividade', es: 'Proactividad' } },
}

const relations = {
	boss: { es: 'Mi Jefe', pt: 'Meu Chefe' },
	pairs: { es: 'Par', pt: 'Par' },
	team: { es: 'Mi Equipo', pt: 'Minha Equipe' },
	other_team: { es: 'Otro Equipo', pt: 'Outra Equipe' },
}

function StarAvaliation({ value }) {
	const renderStars = value => {
		const starIcons = []

		for (let starValue = 1; starValue <= 5; starValue++) {
			let starIcon

			if (starValue <= value) {
				starIcon = <IoStarSharp size={22} key={starValue} style={{ color: '#FBBF23' }} />
			} else if (starValue - value >= 0.1 && starValue - value <= 0.9) {
				starIcon = (
					<div key={starValue} style={{ position: 'relative', display: 'inline-block', width: '22px', height: '22px' }}>
						<IoStarSharp size={22} style={{ position: 'absolute', color: '#E1E8F0' }} />
						<IoStarSharp size={22} style={{ position: 'absolute', color: '#FBBF23', clipPath: 'inset(0 50% 0 0)' }} />
					</div>
				)
			} else {
				starIcon = <IoStarSharp size={22} key={starValue} style={{ color: '#E1E8F0' }} />
			}

			starIcons.push(starIcon)
		}

		return starIcons
	}

	return <div className='tw-flex'>{renderStars(value)}</div>
}

export function FeedbackTable({ data }) {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'
	const [modalFeedback, setModalFeedback] = useState(false)
	const [target, setTarget] = useState(null)

	return (
		<>
			<div className='tw-overflow-x-auto tw-text-sm border tw-rounded-md'>
				<table className='tw-min-w-full '>
					<thead>
						<tr className='tw-bg-gray-100'>
							<th className='tw-px-4 tw-py-2'>Colaborador y Cargo</th>
							<th className='tw-px-4 tw-py-2'>Relación</th>
							<th className='tw-px-4 tw-py-2'>Categoría</th>
							<th className='tw-px-4 tw-py-2'>Evaluation</th>
							<th className='tw-px-4 tw-py-2'>Fecha</th>
							<th className='tw-px-4 tw-py-2'></th>
						</tr>
					</thead>
					<tbody>
						{data.map((item, index) => (
							<tr key={index} className='tw-border-t tw-border-gray-200 tw-bg-white hover:tw-bg-gray-50'>
								<td className='tw-px-4 tw-py-2'>
									<div className='tw-flex tw-items-center tw-space-x-2'>
										<div className='tw-w-12 tw-h-12 tw-bg-gray-100 tw-rounded-full tw-flex tw-items-center tw-justify-center  tw-font-bold tw-text-2xl tw-text-blue-400'>
											{item.employer.name.charAt(0)}
										</div>
										<div>
											<div className='tw-font-semibold'>{item.employer.name}</div>
											<div className='tw-text-sm tw-text-gray-500'>{item.employer.employersJob.name}</div>
										</div>
									</div>
								</td>
								<td className='tw-px-4 tw-py-2'>{relations[item.relation][language] || item.relation}</td>
								<td className='tw-px-4 tw-py-2'>
									<div
										className='tw-inline-block tw-bg-transparent tw-text-gray-800 tw-px-2 tw-py-1 tw-rounded-md'
										style={{ border: `1px solid ${categories[item.category.id].color}` }}
									>
										{categories[item.category.id].name[language]}
									</div>
								</td>
								<td className='tw-px-4 tw-py-2'>
									<div className='tw-flex tw-items-center'>
										<span className='tw-font-semibold tw-mr-2'>{item.rating.toFixed(1)}</span>
										<StarAvaliation value={item.rating} />
									</div>
								</td>
								<td className='tw-px-4 tw-py-2 tw-text-gray-600'>{item.createdAt.split('T')[0]}</td>
								<td className='tw-px-4 tw-py-2'>
									<div
										className='tw-text-purple-500 tw-flex tw-items-center tw-justify-center tw-space-x-1 hover:tw-bg-purple-100 tw-cursor-pointer tw-h-10 tw-w-10 tw-bg-purple-50 tw-rounded-full'
										onClick={() => {
											console.log(item.employer)
											setTarget(item.employer)
											setModalFeedback(true)
										}}
									>
										<FaEye size={16} />
									</div>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>

			{modalFeedback && <ModalFeedback target={target} categories={categories} close={() => setModalFeedback(false)} type='sent' />}
		</>
	)
}
